var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.318 23.887a.91.91 0 0 1-.991-.197l-1.955-1.955a13.687 13.687 0 0 1-2.724 1.735c-1.362.659-3.053 1.2-4.847 1.166-4.293-.08-7.024-1.725-9.144-4.09-1.72-1.92-2.472-4.352-2.644-5.381a.91.91 0 0 1-.012-.15V2.591a.91.91 0 0 1 1.552-.642l1.955 1.955a13.686 13.686 0 0 1 2.724-1.735c1.363-.66 3.054-1.2 4.848-1.166 4.294.08 7.025 1.725 9.144 4.09 1.721 1.92 2.473 4.352 2.644 5.381.009.05.013.1.013.15v12.424a.91.91 0 0 1-.562.84zm-1.257-3.035v-10.15c-.156-.836-.801-2.846-2.191-4.397-1.821-2.03-4.09-3.415-7.826-3.486-1.419-.027-2.82.404-4.021.984-.743.36-1.386.766-1.882 1.129l15.92 15.92zM6.819 4.786v10.15c.156.836.802 2.846 2.192 4.397 1.82 2.03 4.089 3.415 7.825 3.485 1.418.027 2.82-.404 4.02-.985.744-.36 1.387-.766 1.882-1.128L6.818 4.785zM5.985 22.06a.682.682 0 0 0-.682.682v3.637a.682.682 0 0 0 1.364-.001V22.74a.682.682 0 0 0-.682-.681zm9.773 4.622a.682.682 0 1 1 1.363 0v3.636a.682.682 0 1 1-1.362 0v-3.636zm11.287-1.136a.682.682 0 0 0-.681.681V28.5a.682.682 0 0 0 1.363 0v-2.273a.682.682 0 0 0-.681-.681z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOng);
export default __webpack_public_path__ + "static/media/ONG.cbe2099317e806d759a7e99facd1ae25.svg";
export { ForwardRef as ReactComponent };